import { ContextUtils } from "../../utils/ContextUtils";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Context Area
export class AreaContext {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Datasets
    /**
     * Resolves the effective dataset for a context within a workspace.
     *
     * The method loads all workspace contexts once, finds `contextId`, then treats
     * contexts selected in that context's dataset as inherited parent contexts.
     * Parent datasets are resolved recursively, unioned together, and refined by
     * the target context dataset so child filters and exclusions apply to both
     * inherited and local data.
     *
     * Returns a configured `SDKDataset`; it does not fetch the actual scoped
     * tokens, skills, files, or other data entities.
     */
    async getResolvedDatasetForContext(workspaceId, contextId) {
        const contexts = await this.dataCore.getForgeProjectContexts({
            workspaceId,
        });
        const contextsById = new Map(contexts.map((context) => [context.id, context]));
        const context = contextsById.get(contextId);
        if (!context) {
            throw new Error(`Context ${contextId} was not found in workspace ${workspaceId}`);
        }
        return ContextUtils.getResolvedDatasetForContext(context, contexts);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Knowledge files
    async listKnowledgeFiles(workspaceId) {
        return this.dataCore.getKnowledgeFiles(workspaceId);
    }
    async createKnowledgeFile(workspaceId, input) {
        return this.dataCore.createKnowledgeFile(workspaceId, input);
    }
    async updateKnowledgeFile(workspaceId, fileId, input) {
        return this.dataCore.updateKnowledgeFile(workspaceId, fileId, input);
    }
    async deleteKnowledgeFile(workspaceId, input) {
        return this.dataCore.deleteKnowledgeFile(workspaceId, input);
    }
    // MARK: - Knowledge skills
    async listKnowledgeSkills(workspaceId) {
        return this.dataCore.getKnowledgeSkills(workspaceId);
    }
    async createKnowledgeSkill(workspaceId, input) {
        return this.dataCore.createKnowledgeSkill(workspaceId, input);
    }
    async updateKnowledgeSkill(workspaceId, skillId, input) {
        return this.dataCore.updateKnowledgeSkill(workspaceId, skillId, input);
    }
    async deleteKnowledgeSkill(workspaceId, input) {
        return this.dataCore.deleteKnowledgeSkill(workspaceId, input);
    }
}
